<template>
  <OfferList :customer="''"/>
</template>

<script>
import OfferList from '@/components/documents/OfferList.vue'

export default {
  name: 'OfferListView',
  components: {
    OfferList
  }
}
</script>
